module.exports = __webpack_public_path__ + "img/whatsapp.704b0600.png";